export default {
    mutations: {
        SET_DIALOG: 'SET_DIALOG',
        SET_DIRTY: 'SET_DIRTY',
        SET_NEXT_PAGE: 'SET_NEXT_PAGE',
        SET_CANCELDELIVERYDIALOG: 'SET_CANCELDELIVERYDIALOG',
    },
}
